"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorFrom = void 0;
/**
 * Safely assemble an `Error` providing a fallback error message.
 */
const errorFrom = (anything, fallbackMessage = 'unknown error') => {
    if (anything instanceof Error) {
        return anything;
    }
    if (typeof anything === 'string' || anything instanceof String) {
        return new Error(anything);
    }
    return new Error(fallbackMessage);
};
exports.errorFrom = errorFrom;
//# sourceMappingURL=error.utils.js.map